(function () {
	"use strict";
	angular.module("app.shared.services").factory("httpRequest", ["$http", "$q", "$window",
		function ($http, $q, $window) {
			// ------------------------------------------------------------------------ Api Call Functions ---------------------------------------------------------------------------- //
			var newDoGetRequest = function (url, opts) {
				return $q(function (resolve, reject) {
					var options = opts || {};
					var headers = getHeaders(false, options);
					$http.get(url, { headers: headers, withCredentials: true }).then(
						function (response) { resolve(response.data); },
						function (response) {
							onRequestError(response, options.skipErrorLogging);
							reject(response);
						}
					);
				});
			};

			var newDoPostRequest = function (url, data, opts) {
				return $q(function (resolve, reject) {
					var options = opts || {};
					var headers = getHeaders(true, options);
					$http.post(url, data, { headers: headers, withCredentials: true }).then(
						function (response) { resolve(response.data); },
						function (response) {
							onRequestError(response, options.skipErrorLogging);
							reject(response);
						}
					);
				});
			};

			var newDoPutRequest = function (url, data, opts) {
				return $q(function (resolve, reject) {
					var options = opts || {};
					var headers = getHeaders(true, options);
					$http.put(url, data, { headers: headers, withCredentials: true }).then(
						function (response) { resolve(response.data); },
						function (response) {
							onRequestError(response, options.skipErrorLogging);
							reject(response);
						}
					);
				});
			};

			var newDoDeleteRequest = function (url, opts) {
				return $q(function (resolve, reject) {
					var options = opts || {};
					var headers = getHeaders(false, options);
					$http.delete(url, { headers: headers, withCredentials: true }).then(
						function (response) { resolve(response.data); },
						function (response) {
							onRequestError(response, options.skipErrorLogging);
							reject(response);
						}
					);
				});
			};

			var doCancelableGetRequest = function (url, opts) {
				var options = opts || {};
				var params = options.params || null;
				var headers = getHeaders(false, options);

				var reqCanceller = $q.defer();
				var deferred = $q.defer();
				var reqPromise = $http.get(url, { params: params, timeout: reqCanceller, headers: headers, withCredentials: true }).then(
					function (response) {
						reqCanceller.reject();
						deferred.resolve;
						return response.data;
					},
					function (response) {
						onRequestError(response, options.skipErrorLogging);
						deferred.reject;
					}
				);

				return { promise: reqPromise, canceller: reqCanceller };
			};
			// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
			// ---------------------------------------------------------------------- Request Error Handling -------------------------------------------------------------------------- //
			var onRequestError = function (response, skipErrorLogging) {
				if (skipErrorLogging != true) { logError(response); }
				if (response.status == 401) { handleUnauthorized(); }
			};

			var handleUnauthorized = function () {
				$.removeCookie('currentValidUser', { path: '/' });
				$.removeCookie('primaryLocKey', { path: '/' });

				$window.sessionStorage.removeItem("userAppInfo");
				$window.location.assign("/");
			};

			var logError = function (response) {
				return;
				try {
					var requestData = response.config.data;
					var fullURL = response.config.url;
					if (fullURL.indexOf("/count") != -1 || response.status == -1) return;
					var urlBlocks = response.config.url.split("/");
					if (urlBlocks[0] == "..") urlBlocks.shift();
					if (urlBlocks[0] == "api") urlBlocks.shift();

					var firstDIR = null;
					var secondDIR = null;
					if (urlBlocks.length > 0) firstDIR = urlBlocks[0].split("?")[0];
					if (urlBlocks.length > 1) secondDIR = urlBlocks[1].split("?")[0];

					var reponseData = response.data;
					var currentUser = getCurrentUser();
					var userId = currentUser == null ? null : currentUser.UserID;
					var errorObj = {
						ToData: JSON.stringify(response.config.data),
						FullURL: response.config.url,
						FirstDir: firstDIR,
						SecondDir: secondDIR,
						Data: JSON.stringify(reponseData),
						UserID: userId,
						Method: response.config.method
					};
					newDoPostRequest("/api/HttpErrorLog", errorObj, { skipErrorLogging: true });
				}
				catch (err) {
					console.log("Error on Reporting Error: Error + " + err);
				}
			};
			// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
			// -------------------------------------------------------------------------- Helper Functions ---------------------------------------------------------------------------- //
			var getHeaders = function (isEnclosingEntity, options) {
				var currentUser = getCurrentUser();
				var userId = null;
				var locKey = null;
				var modKey = null;
				var useWinAuth = null;
				if (currentUser != null) {
					userId = currentUser == null ? null : currentUser.UserID;
					locKey = currentUser == null ? null : currentUser.LocKey;
					modKey = currentUser == null ? null : currentUser.ModuleKey;
					useWinAuth = currentUser == null ? null : currentUser.UseWinAuth;
				}

				var taskKey = options.TaskKey || null;
				var skipErrorLogging = options.SkipErrorLogging == null ? false : options.SkipErrorLogging;
				var sessionID = options.SessionID || null;
				if (options.UserID > 0) { userId = options.UserID; }
				if (options.LocKey > 0) { locKey = options.LocKey; }

				var allHeaders = {
					'Accept': 'application/json',
					'ModuleKey': modKey,
					'SessionID': sessionID,
					'IgnoreLog': skipErrorLogging
				};

				if (userId != null) { allHeaders['UserID'] = userId; }
				if (locKey != null) { allHeaders['LocKey'] = locKey; }
				if (taskKey != null) { allHeaders['TaskKey'] = taskKey; }
				if (useWinAuth != null) { allHeaders['UseWinAuth'] = useWinAuth; }
                allHeaders['TimezoneOffset'] = getTimezoneOffset();

				if (isEnclosingEntity) allHeaders['Content-Type'] = 'application/json';
				return allHeaders;
            };


            function getTimezoneOffset() {               
                var x = new Date();
                var currentTimeZoneOffsetInHours = x.getTimezoneOffset() / 60;
                return currentTimeZoneOffsetInHours * -1;
            }

			var getCurrentUser = function () {
				var user = $.cookie('currentValidUser') || null;
				if (user != null) { user = JSON.parse(user); }
				else { return null; }

				var appInfo = JSON.parse($window.sessionStorage.getItem("userAppInfo")) || null;
				if (appInfo !== null) {
					user.LocKey = appInfo.LocKey;
					user.ERPKey = appInfo.ERPKey;
					user.ModuleKey = appInfo.ModuleKey;
					user.locations = appInfo.locations;
				}

				return user;
			};

			// This should be used when using Odata Filtering with any string. Passing strings in as a URL Parameter should NOT use this function.
			var encodeUriComponent = function (urlSeg) {
				var seg = angular.copy(urlSeg);
				seg = encodeURIComponent(seg);
				seg = seg.replace(new RegExp("'", 'g'), "''");
				return seg;
			};
			// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
			// -------------------------------------------------------------------- Old Functions To Deprecate ------------------------------------------------------------------------ //

			// options:  onSuccess, onError, taskKey, canceller(by reference)
			// & cancellerOverride? <-- where is this used?
			// also, can we get rid of PARAMS?
			var doGetRequest = function (url, params, successCallback, errorCallback, cancellerOverride) {
				// temporarily handle old way of calling httpRequest
				var options = convertToOptions(successCallback, errorCallback);
				if (params != null) options.params = params;
				if (cancellerOverride != null) options.cancellerOverride = cancellerOverride;
				return { promise: doGetRequest_New(url, options), canceller: options.canceller };
			};

			var doGetRequest_New = function (url, options) {
				var options = options || {};
				var params = options.params || null;
				var onSuccess = options.onSuccess;
				var onError = options.onError;
				var cancellerOverride = options.cancellerOverride;

				var headers = getHeaders(false, options);

				var canceller = $q.defer();
				if (cancellerOverride != null && cancellerOverride != undefined) {
					canceller = cancellerOverride;
				}

				var deferred = $q.defer();
				var promise = $http.get(url, { params: params, timeout: canceller, headers: headers, withCredentials: true }).then(
					function (response) {
						canceller.reject();
						deferred.resolve;
						if (onSuccess != null || onSuccess != undefined) {
							onSuccess(response.data);
						} else {
							return response.data;
						}

					},
					function (response) {
						return handleErrorResponse(response, onError, deferred, canceller, options.skipErrorLogging);
					}
				);

				options.canceller = canceller; // pass "canceller" back by reference
				return promise;
			};

			// used to temporarily handle the old way of using httpRequest
			// returns the new "options" object
			function convertToOptions(successCallback, errorCallback) {
				if (successCallback == null && errorCallback == null) return {};  // only url & data were passed in, no options

				if (typeof successCallback === "function" || typeof errorCallback === "function") {
					// OLD way was used.  successCallback and/or errorCallback are actual callbacks
					return { onSuccess: successCallback, onError: errorCallback };
				} else {
					// NEW way was used.  successCallback IS the options object
					return successCallback;
				}
			}

			function handleErrorResponse(response, onError, deferred, canceller, skipErrorLogging) {
				if (skipErrorLogging != true) logError(response);
				if (canceller != null) canceller.reject();
				deferred.reject();

				if (response.status === 401) {
					handleUnauthorized();
				}
				if (onError != null) onError(response.statusText, response.status, response.data);
				return $q.reject(response);
			}
			// ---------------------------------------------------------------------------- End Section ------------------------------------------------------------------------------- //
			return {
				doGetRequest: newDoGetRequest,
				doPostRequest: newDoPostRequest,
				doPutRequest: newDoPutRequest,
				doDeleteRequest: newDoDeleteRequest,
				encodeUriComponent: encodeUriComponent,

				doGetRequest_OLD: doGetRequest,
				doCancelableGetRequest: doCancelableGetRequest
			};
		}
	]);
})();